// Bottom-tab / sidebar destinations shared by the mobile and desktop portal shells. `d` holds one or more
// SVG path strings drawn at a shell-specific size.
export interface PortalTab {
  to: string;
  labelKey: string;
  fallback: string;
  desktopLabelKey?: string;
  desktopFallback?: string;
  paths: string[];
  end?: boolean;
}

export const PORTAL_TABS: PortalTab[] = [
  { to: '/', labelKey: 'tabs.home', fallback: 'Home', desktopLabelKey: 'tabs.overview', desktopFallback: 'Overview', end: true, paths: ['m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'] },
  { to: '/appointments', labelKey: 'tabs.appointments', fallback: 'Visits', desktopLabelKey: 'tabs.appointmentsDesktop', desktopFallback: 'Appointments', paths: ['M8 2v4', 'M16 2v4', 'M3 10h18', 'M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z'] },
  { to: '/records', labelKey: 'tabs.records', fallback: 'Records', paths: ['M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z', 'M14 2v6h6'] },
  { to: '/billing', labelKey: 'tabs.billing', fallback: 'Billing', paths: ['M2 5h20v14H2z', 'M2 10h20'] },
  { to: '/profile', labelKey: 'tabs.profile', fallback: 'Profile', desktopLabelKey: 'tabs.profilesAccess', desktopFallback: 'Profiles & access', paths: ['M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10z', 'M4 22a8 8 0 0 1 16 0'] },
];
